/**
 * @ngdoc directive
 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
 * @restrict E
 * @scope
 * @description Componente rappresentante il dettaglio del saldo dossier
 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
 */
(function () {
  'use strict';
  var CashflowCtrl = function (
    $http,
    $scope,
    $window,
    $q,
    $stateParams,
    $state,
    $location,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    uiGridConstants,
    messaggiSrvc,
    userSrvc,
    $uibModal,
    brioSrvc,
    service,
    tableService,
    deskSrvc
  ) {
    var self = this;
    this.$uibModal = $uibModal;
    this.$http = $http;
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.userSrvc = userSrvc;
    this.brioSrvc = brioSrvc;
    this.deskSrvc = deskSrvc;
    this.tableService = tableService;
    this.posizione = {};
    this.ndgs = [];
    this.selectNdg = [];
    this.selectRapporti = [];
    this.CONSTANTS = CONSTANTS;
    this.startDate = new Date();
    this.endDate = new Date();
    this.minDate = new Date();
    this.maxDate = new Date('2099-12-31');
    this.dataTable = null;
    this.gridTable = {};
    this.avvertenze = [];

    this.filterBox = {
      totaleScadenza: true,
      cedole: true,
      rimborsi: true,
      dividendi: true,
      strumentiUS: false
    };

    this.endDate.setFullYear(this.endDate.getFullYear() + 1);

    $scope.msg = labelSrvc.getLabel;
    this.spinner = {
      customerData: true,
      filterNdg: true,
      cashflow: false
    };
    this.messaggiFctr.chiudiLoaderBrio();

    var self = this;

    /*
     * ----------------------------
     * START METODI INIT CONTROLLER
     * ----------------------------
     */
    service
      .promiseCustomerData($stateParams.finRapporto)
      .then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.posizione = {};
            return;
          }
          self.posizione = response.data;
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      )
      .finally(function () {
        self.spinner.customerData = false;
      });

    service
      .promiseFilterNdg($stateParams.finRapporto)
      .then(function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          return;
        }
        self.ndgs = response.data.result;
        self.selectNdg = [];
        self.ndgs.forEach(function (ndg) {
          self.selectNdg.push({
            ndg: ndg.ndg,
            intestazione: ndg.intestazione,
            selected: true
          });
        });
        self.reloadRapporti();
      })
      .finally(function () {
        self.spinner.filterNdg = false;
      });

    // Chiamo il getDossier per inserire le info nel customerdata

    labelSrvc.labelsPronte.then(function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.aggiungiEntry(
          labelSrvc.getLabel('dossier.cashflow.titolo')
        );
      }

      for (var label in labelSrvc.labels) {
        if (label.startsWith('cashflow.avvertenze.'))
          self.avvertenze.push(labelSrvc.getLabel(label));
      }
    });
    /*
     * --------------------------
     * END METODI INIT CONTROLLER
     * --------------------------
     */

    this.filterCashFlow = function () {
      self.spinner.cashflow = true;
      var rapporti = [];
      self.selectRapporti.forEach(function (rapp) {
        if (rapp.selected) {
          rapporti.push(rapp.rapporto);
        }
      });
      if (rapporti.length === 0) {
        self.messaggiFctr.addMessage({
          type: 'E',
          message: 'Nessun rapporto selezionato'
        });
        self.spinner.cashflow = false;
        return;
      }
      service
        .promiseGetCashflow(rapporti, self.startDate, self.endDate)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          self.dataTable = response.data.result;
          self.dataTable.forEach(function (item) {
            if (!item.codiceMovimento) {
              item.codiceMovimento = 'CED';
            }
          });
          self.loadTable();
        })
        .finally(function () {
          self.spinner.cashflow = false;
        });
    };

    this.loadTable = function () {
      self.gridTable = self.tableService.getTable(
        self.dataTable,
        self.filterBox
      );
    };

    this.reloadRapporti = function () {
      var tmpRapporto = self.selectRapporti.concat([]);
      self.selectRapporti = [];
      self.selectNdg.forEach(function (ndg) {
        if (ndg.selected) {
          self.ndgs
            .find(function (n) {
              return n.ndg === ndg.ndg;
            })
            .rapporti.forEach(function (rapp) {
              var indexFind = self.selectRapporti.findIndex(function (rp) {
                return rp.rapporto === rapp.rapporto;
              });
              if (indexFind !== -1) {
                // Già censito
                self.selectRapporti[indexFind].intestazione =
                  ndg.ndg + '/' + self.selectRapporti[indexFind].intestazione;
              } else {
                var item = tmpRapporto.find(function (rp) {
                  return rp.rapporto === rapp.rapporto;
                });
                // Inserisco
                self.selectRapporti.push({
                  rapporto: rapp.rapporto,
                  intestazione: ndg.ndg + ' - Rapporto ' + rapp.rapporto,
                  selected: !!item ? item.selected : false
                });
                var dtStipula = new Date(rapp.dataStipula);
                 self.minDate =
                  dtStipula.getTime() < self.minDate.getTime()
                    ? dtStipula
                    : self.minDate;
              } 
            });
        }
      });
    };

    this.getExcel = function () {
      self.spinner.cashflow = true;
      this.tableService
        .excel(self.dataTable, self.filterBox)
        .then(function () {})
        .finally(function () {
          self.spinner.cashflow = false;
        });
    };

    this.indietro = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (deskSrvc.isDesk) {
        deskSrvc.popEntry();
      }
      $state.go('home.schedaDossierDiv', {
        ndg: $stateParams.ndg,
        finCodiceRapporto: $stateParams.finRapporto,
        finDivisa: $stateParams.finDivisa,
        finCambio: $stateParams.finCambio,
        finDecimali: $stateParams.finDecimali
      });
    };
  };

  CashflowCtrl.$inject = [
    '$http',
    '$scope',
    '$window',
    '$q',
    '$stateParams',
    '$state',
    '$location',
    'FIN_CONSTANTS',
    'FinLabelSrvc',
    'FinMessaggiFctr',
    'uiGridConstants',
    'CblMessageSrvc',
    'FinUserSrvc',
    '$uibModal',
    'FinBrioSrvc',
    'CashflowSrvc',
    'CashflowTableSrvc',
    'FinDeskSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cashflow/cashflow.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var CashflowComponent = {
    bindings: {},
    controller: CashflowCtrl,
    controllerAs: 'cashflowCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaCahflow', CashflowComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/cashflow/cashflow.cmpt.js
 ** module id = 50
 ** module chunks = 1 2
 **/